import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import FormLayout from "../FormLayout";
import CustomButton from "../CustomButton";
import { useDispatch } from "react-redux";
import { push, goBack } from "redux-first-history";
import SpringboroTerms from "./SpringboroTerms";

const TermsAndConditions = ({termsSigned}: {termsSigned: boolean}) => {
  const dispatch = useDispatch();

  return (termsSigned ? (<FormLayout
    title={"Terms and Conditions"}
    subtitle={"Terms and Conditions"}
    description={"The following are our terms and conditions that were accepted prior to creating a Lime account."}
  >
    <Grid 
      container
      direction="column"
      alignItems="center"
      justifyContent="space-evenly"
      spacing={3}>
      <Grid size={8}>
        <Box sx={{ height: '20em', overflow: 'scroll', mt: '1em'}}>
          <SpringboroTerms />
        </Box>
      </Grid>
    </Grid>
    <div className='btn-container single start'>
        <CustomButton
          variant="outlined"
          disableElevation={false}
          label={"Back"}
          type="submit"
          onClick={() => dispatch(goBack())}
          buttonSize="btn-lg"
        />
    </div>
  </FormLayout>) : (<Grid 
    container
    direction="column"
    alignItems="center"
    justifyContent="space-evenly"
    spacing={3}>
    <Grid size={12}>
      <Box>
        <SpringboroTerms />
      </Box>
    </Grid>
  </Grid>));
}

export default TermsAndConditions;
